import { RouteConfig } from '@abaco/web-common/src/app';

const routes: RouteConfig[] = [
    {
        name: "import-company-v2",
        path: "/import-company-v2",
        component: () => import("./components/ImportCompanyV2TileContainer.vue"),
    },
    {
        name: "import-company",
        path: "/import-company",
        component: () => import("./components/ImportCompanyTileContainer.vue"),
    },
    {
        name: "activation-form",
        path: "/activation-form",
        component: () => import("./components/ActivationFormTileContainer.vue"),
        meta: { navbarItems: ["farm-select-nav-bar-item"] }
    },
    {
        name: "help-coldiretti",
        path: "/help-coldiretti",
        component: () => import("./components/HelpColdirettiTileContainer.vue"),
    },
    {
        name: "system-monitoring",
        path: "/system-monitoring",
        component: () => import("./components/SystemMonitoringTileContainer.vue"),
    },
    {
        name: "gias-qdc",
        path: "/gias-qdc",
        component: () => import("./components/QdcTileContainer.vue"),
        meta: { navbarItems: ["farm-select-nav-bar-item"] }
    },
    {
        name: "gias-qdc-new",
        path: "/gias-qdc-new",
        component: () => import("./components/QdcNewTileContainer.vue"),
        meta: { navbarItems: ["farm-select-nav-bar-item"] }
    },
];

export default routes;
